import { guid } from 'apps/builder/lib/utils'
import { createScreenData } from './entities'

const getExtraFieldTypeAttributes = fieldType => {
  switch (fieldType) {
    case 'Email':
      return { style: 10 }
    default:
      return {}
  }
}

export const processAiExtractedFields = (
  extractedFields,
  pdfBlob,
  entryTypes,
  pages = [],
  layouts = []
) => {
  const result = {
    sheets: [],
    sections: [],
    pages: [],
    layouts: [],
    entries: [],
    elements: [],
    pdf_path: pdfBlob,
  }
  const pageDataMap = new Map()
  const entryCountByPage = new Map()
  const defaultEntryType = entryTypes.find(({ type }) => type === 'Text')

  extractedFields.forEach(field => {
    const {
      label,
      page_number: pageNumber,
      element_type: fieldType,
      bounding_box: boundingBox,
    } = field

    if (!label?.trim()) return

    let pageData = pageDataMap.get(pageNumber)
    if (!pageData) {
      const { section, sheet } = createScreenData(pageNumber)
      result.sections.push(section)
      result.sheets.push(sheet)

      const updatedPage = {
        ...(pages.find(p => p.page_number === pageNumber) || {}),
        section_ids: [section.id],
      }
      result.pages.push(updatedPage)

      const updatedLayout = {
        ...(layouts.find(l => l.page_id === updatedPage.id) || {}),
        section_id: section.id,
      }
      result.layouts.push(updatedLayout)

      pageData = { section, sheet, page: updatedPage, layout: updatedLayout }
      pageDataMap.set(pageNumber, pageData)
      entryCountByPage.set(pageNumber, 0)
    }

    const entryData =
      entryTypes.find(entryType => entryType.type === fieldType) ||
      defaultEntryType
    const entryGuid = guid()
    const entryCount = entryCountByPage.get(pageNumber)

    const entry = {
      ...entryData,
      entry_type_id: entryData.id,
      guid: entryGuid,
      position: entryCount,
      label,
      sheet_id: pageData.sheet.id,
      ...getExtraFieldTypeAttributes(fieldType),
    }

    const element = {
      page_number: pageNumber,
      page_id: pageData.page.id,
      entry_guid: entryGuid,
      element_type: entryData.type,
      layout_id: pageData.layout.id,
      position: {
        x: boundingBox.left,
        y: boundingBox.top,
        width: boundingBox.width,
        height: boundingBox.height,
      },
    }

    result.entries.push(entry)
    result.elements.push(element)
    entryCountByPage.set(pageNumber, entryCount + 1)
  })

  return result
}
